//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data () {
    return {}
  },
  props: {
    degree: {
      type: Number,
      required: true
    }
  },
  computed: {
    rotate2 () {
      if (this.degree == 0) {
        return {
          degree: '0',
          bgColor: '#F3F3F3'
        }
      } else if (this.degree <= 90) {
        return {
          degree: `-${this.degree}`,
          bgColor: '#FFB403'
        }
      } else {
        return {
          degree: '-90',
          bgColor: '#FFB403'
        }
      }
    },
    rotate3 () {
      if (this.degree <= 90) {
        return {
          degree: '-180',
          bgColor: '#F3F3F3'
        }
      } if (this.degree > 90 && this.degree <= 180) {
        return {
          degree: `-${this.degree}`,
          bgColor: '#FFB403'
        }
      } else {
        return {
          degree: '-180',
          bgColor: '#FFB403'
        }
      }
    },
    rotate4 () {
      if (this.degree <= 180) {
        return {
          degree: '-270',
          bgColor: '#F3F3F3'
        }
      } if (this.degree > 180 && this.degree <= 270) {
        return {
          degree: `-${this.degree}`,
          bgColor: '#FFB403'
        }
      } else {
        return {
          degree: '-270',
          bgColor: '#FFB403'
        }
      }
    },
    rotate1 () {
      if (this.degree <= 270) {
        return {
          degree: '0',
          bgColor: '#F3F3F3'
        }
      } else if (this.degree < 360) {
        return {
          degree: `${360-this.degree}`,
          bgColor: '#FFB403'
        }
      } else {
        return {
          degree: '0',
          bgColor: '#FFB403'
        }
      }
    }
  }
}
